import React from 'react';
import PropTypes from 'prop-types';
import get from 'just-safe-get';
import { RichText } from 'prismic-reactjs';
import { Box, Grid, Container, TextLink } from '@feast-it/pesto';

import Link from '../../components/Link';
import ImageAndCopy from '../../components/ImageAndCopy';

// We are testing a way of personalising landing pages based on keywords that come from Google ads
// This component contains a 'hack' to check if the keywords contain wedding, if so, display a fixed set of images
const weddingImages = [
  'https://images.prismic.io/feast-it/0b890c2a-68fc-4576-8331-e1b2fff18b0f_sizzling_bbq_wedding_sharing_board.jpg',
  'https://images.prismic.io/feast-it/d4cbc124-b479-4eed-be2f-5f71450b8598_sizzling_bbq_wedding_memorable_event.jpg',
];

const LinkInCopy = (_, element, content) => {
  const link = get(element, 'data.url');

  return (
    <TextLink href={link} linkComponent={Link} color="primary">
      {content}
    </TextLink>
  );
};

const ImageAndCopyContainer = ({ keyword, ...rawData }) => {
  const data = {
    items: get(rawData, 'items'),
    backgroundColor: get(rawData, 'primary.background_color'),
  };

  const isWeddingThemed = keyword && keyword.contains('wedding');

  return (
    <Box
      as="section"
      py={{ _: 10, m: 11 }}
      px={{ _: 'gutter._', s: 'gutter.s', m: 'gutter.m' }}
      bg={data.backgroundColor === 'white' ? 'white' : 'greyLight'}
    >
      <Container>
        <Grid gridRowGap={11}>
          {data.items.map((itemData, i) => {
            const item = {
              title: get(itemData, 'content_title'),
              copy: get(itemData, 'content_copy'),
              image:
                isWeddingThemed && i < weddingImages.length
                  ? weddingImages[i]
                  : get(itemData, 'content_image.url'),
              layout: get(itemData, 'content_layout'),
              ctaText: get(itemData, 'content_cta_text'),
              ctaLink: get(itemData, 'content_cta_link.url'),
            };

            const isImageLeft = item.layout === 'image-left';

            return (
              <ImageAndCopy
                key={`image-and-copy-${i}`}
                {...item}
                text={
                  <RichText
                    render={item.copy}
                    serializeHyperlink={LinkInCopy}
                  />
                }
                isImageLeft={isImageLeft}
              />
            );
          })}
        </Grid>
      </Container>
    </Box>
  );
};

ImageAndCopyContainer.propTypes = {
  keyword: PropTypes.string,
};

export default ImageAndCopyContainer;
